"use client";
import Image from "next/image";
import Link from "next/link";
import { useCallback, useRef } from "react";
import MobileMenu from "./MobileMenu";
import GetInvolvedButton from "@/component/common/GetInvolvedButton";
import { useLanguage } from "@/utils/LanguageContext";

import logo_1 from "@/assets/img/logo/logo.png";

const Sidebar = ({ isActive, setIsActive }: any) => {
    const { lang } = useLanguage();
    const sidebarRef = useRef<HTMLDivElement | null>(null);

    const closeSidebar = useCallback(() => {
        if (typeof document !== "undefined") {
            const activeElement = document.activeElement;
            if (
                activeElement instanceof HTMLElement &&
                sidebarRef.current?.contains(activeElement)
            ) {
                activeElement.blur();
            }
        }

        setIsActive(false);
    }, [setIsActive]);

    return (
        <div
            ref={sidebarRef}
            className={isActive ? "mobile-menu-visible" : ""}
            aria-hidden={!isActive}
        >
            <div className="mobile-menu">
                <nav className="menu-box" id="mobile-site-nav">
                    <button
                        type="button"
                        onClick={closeSidebar}
                        className="close-btn"
                        aria-label="Close menu"
                    >
                        <i className="fas fa-times"></i>
                    </button>
                    <div className="nav-logo">
                        <Link href={`/${lang}/home`} prefetch={false}><Image src={logo_1} alt="Invtron DAO" /></Link>
                    </div>
                    <div className="menu-outer">
                        <MobileMenu closeSidebar={closeSidebar} />
                        <GetInvolvedButton
                            className="mobile-menu-cta"
                            onClick={closeSidebar}
                        />
                    </div>
                    <div className="social-links">
                        <ul className="clearfix list-wrap">
                            <li>
                                <a href="https://www.facebook.com/invtrondao" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                                    <i className="fab fa-facebook-f"></i>
                                </a>
                            </li>
                            <li>
                                <a href="https://x.com/invtrondao" target="_blank" rel="noopener noreferrer" aria-label="X">
                                    <i className="fab fa-twitter"></i>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.instagram.com/invtron/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                                    <i className="fab fa-instagram"></i>
                                </a>
                            </li>
                            <li>
                                <a href="https://www.linkedin.com/company/invtron-dao/" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                                    <i className="fab fa-linkedin-in"></i>
                                </a>
                            </li>
                            <li>
                                <a href="https://youtube.com/" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                                    <i className="fab fa-youtube"></i>
                                </a>
                            </li>
                        </ul>
                    </div>
                </nav>
                <style jsx global>{`
                    .mobile-menu .mobile-menu-cta {
                        padding: 0 20px;
                        margin-top: 18px;
                    }

                    .mobile-menu .mobile-menu-cta .get-involved-btn {
                        width: 100%;
                        min-width: 0;
                        justify-content: center;
                    }
                `}</style>
            </div>
            <div onClick={closeSidebar} className="menu-backdrop"></div>
        </div>
    )
}

export default Sidebar
